import { intl } from 'util/lang/helpers';

export const DEFAULT_HTML_TITLE = intl.formatMessage({
  defaultMessage:
    'MapTitan - Find where you belong - Discover your best cities and towns to live',
});
